/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateDoctorTitleRequest
 */
export interface UpdateDoctorTitleRequest {
    /**
     * First line of the doctor’s title.
     * @type {string}
     * @memberof UpdateDoctorTitleRequest
     */
    titleLine1: string;
    /**
     * Second line of the doctor’s title.
     * @type {string}
     * @memberof UpdateDoctorTitleRequest
     */
    titleLine2: string;
    /**
     * doctor’s title.
     * @type {string}
     * @memberof UpdateDoctorTitleRequest
     */
    title: string;
}

/**
 * Check if a given object implements the UpdateDoctorTitleRequest interface.
 */
export function instanceOfUpdateDoctorTitleRequest(value: object): value is UpdateDoctorTitleRequest {
    if (!('titleLine1' in value) || value['titleLine1'] === undefined) return false;
    if (!('titleLine2' in value) || value['titleLine2'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    return true;
}

export function UpdateDoctorTitleRequestFromJSON(json: any): UpdateDoctorTitleRequest {
    return UpdateDoctorTitleRequestFromJSONTyped(json, false);
}

export function UpdateDoctorTitleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateDoctorTitleRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'titleLine1': json['titleLine1'],
        'titleLine2': json['titleLine2'],
        'title': json['title'],
    };
}

export function UpdateDoctorTitleRequestToJSON(json: any): UpdateDoctorTitleRequest {
    return UpdateDoctorTitleRequestToJSONTyped(json, false);
}

export function UpdateDoctorTitleRequestToJSONTyped(value?: UpdateDoctorTitleRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'titleLine1': value['titleLine1'],
        'titleLine2': value['titleLine2'],
        'title': value['title'],
    };
}

